export default "__VITE_ASSET__gc9qYibx__"